
interface ColumnItem {
    id: number;
    name: string;
    checked: boolean;
  }

  export const initialColumnTeams = [
    { id: 1, name: 'NAME', checked: true, key:'name' }, 
    { id: 2, name: 'CREATED AT', checked: true, key:'createdDT' }, 
    { id: 3, name: 'MODIFIED ON', checked: true, key:'updatedDT' }, 
    { id: 4, name: 'STATUS', checked: true, key:'status' }, 

  ];
  
